import React, { useState, useEffect } from 'react';
import HeadSub from '../../../../components/comm/HeadSub';
import ToastPopup from '../../../../components/comm/ToastPopup';
//import MobileTelecom from '../../../../components/box/MobileTelecom';
import style from './FindId.module.css';
import URL from '../../../../constants/url';
import { useLocation, useNavigate } from 'react-router-dom';

import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import { getMaskUserId } from '../../../../assets/js/comm';


const FindId = () => {

    const navigate = useNavigate();

    const location = useLocation();
    const { state } = location; //

    console.log(" ============> FindId state ", state);

    const [step, setStep] = useState(1);
    const [toast, setToast] = useState(false);
    const [open, setOpen] = useState(false);

    const [name, setName] = useState('');
    const [birth, setBirth] = useState('');
    const [genderCode, setGenderCode] = useState('');
    const [telecom, setTelecom] = useState('');
    const [phone, setPhone] = useState('');
    const [verificationCode, setVerificationCode] = useState('');

    const [timeLeft, setTimeLeft] = useState(180); // 3분 = 180초
    const [isTimeout, setIsTimeout] = useState(false);

    const onDismiss = () => setOpen(false);

    const lengthChk = (e) => {
        if (e.target.value.length > e.target.maxLength) {
            e.target.value = e.target.value.slice(0, e.target.maxLength);
        }
    };

    const onTelecomSelect = (selectedTelecom) => {
        setTelecom(selectedTelecom);
        setOpen(false);
    };


    useEffect(() => {

        if(state?.usrId !== undefined) {
            setStep(6);
        }
    }, [state?.usrId]);

    useEffect(() => {
        if (step === 5 && timeLeft > 0) {
            const timer = setInterval(() => {
                setTimeLeft((prev) => prev - 1);
            }, 1000);
            return () => clearInterval(timer);
        } else if (timeLeft === 0) {
            setIsTimeout(true);
        }
    }, [timeLeft, step]);

    const formatTime = (seconds) => {
        const min = String(Math.floor(seconds / 60)).padStart(2, '0');
        const sec = String(seconds % 60).padStart(2, '0');
        return `${min}:${sec}`;
    };


    const handleNext = () => {
        // 휴대폰 번호 입력 단계에서 인증번호 요청 버튼 클릭
        if (step === 4 && phone.length >= 10) {
            // 인증번호 요청 타이머 초기화
            setTimeLeft(180);
            setIsTimeout(false);
            setStep(5);
        } else if (step < 5) {
            setStep(step + 1);
        } else if ( step === 6 ) {
            handleOnBack();
        } else {
            setToast(true);
        }
    };


    const handleOnBack = () => {
        navigate(URL.LOGIN_MAIN, {
            replace: true,
            state: { refreshAt: false }
        });
    };

    useEffect(() => {
        if (step === 4 && verificationCode.length > 0) {
            setStep(5); // 인증번호 입력 시 자동으로 인증번호 입력란 노출
        }
    }, [verificationCode, step]);

    return (
        <>
            <HeadSub title="아이디 찾기" onBack={handleOnBack} />

            <div id="sub-content" data-layout="white">
                <div className='inner-wrap' data-padding="30">


                    <div className={style['content-box']}>

                        { step > 6 &&
                            <strong className={style['title']}>
                                { step === 1 ? '이름을 입력해 주세요'
                                    : step === 2 ? '생년월일을 입력해 주세요'
                                        : step === 3 ? '통신사를 선택해주세요'
                                            : step === 4 ? '휴대폰 번호를 입력해 주세요'
                                                : step === 5 ? '인증번호를 입력해 주세요 '
                                                    : ''
                                }

                            </strong>
                        }

                        {step >= 5 && step < 6 && (
                            <div className={style['input-wrap']}>
                                <div className='animation-2'>
                                    <span className={style['input-tit']}>인증번호</span>
                                    <div className={style['input-box']}>
                                        <input
                                            type="number"
                                            placeholder="인증번호를 입력해주세요"
                                            value={verificationCode}
                                            onChange={(e) => setVerificationCode(e.target.value)}
                                        />
                                        <span className={style['line']}></span>
                                        <button className={style['cancel-btn']} onClick={() => setVerificationCode('')}></button>
                                    </div>
                                    <div className={style['input-bottom']}>
                                    <span className={style['time']}>
                                        {isTimeout ? '인증시간 초과' : formatTime(timeLeft)}
                                    </span>
                                        <button
                                            className={style['request-btn']}
                                            disabled={!isTimeout}
                                            onClick={() => {
                                                setTimeLeft(180); // 타이머 초기화
                                                setIsTimeout(false);
                                                setVerificationCode('');
                                            }}

                                        >
                                            <span>인증번호 재요청</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        {step >= 4 && step < 6 && (
                            <div className={style['input-wrap']}>
                                <div className='animation-2'>
                                    <span className={style['input-tit']}>휴대폰 번호</span>
                                    <div className={style['input-box']}>
                                        <input
                                            type="number"
                                            placeholder="휴대폰 번호를 입력해주세요"
                                            value={phone}
                                            onChange={(e) => setPhone(e.target.value)}
                                        />
                                        <span className={style['line']}></span>
                                    </div>
                                </div>
                            </div>
                        )}

                        {step >= 3 && step < 6 && (
                            <div className={style['input-wrap']}>
                                <div className='animation-2'>
                                    <span className={style['input-tit']}>통신사</span>
                                    <div className={style['input-box']} data-type-input="btn">
                                        <input
                                            type="button"
                                            placeholder={telecom || '통신사 선택'}
                                            className={style['telecom-input']}
                                            onClick={() => setOpen(true)}
                                            value={telecom}
                                            readOnly
                                        />
                                        <span className={style['line']}></span>
                                    </div>
                                </div>
                            </div>
                        )}

                        {step >= 2 && step < 6 && (
                            <div className={style['input-wrap']}>
                                <div className='animation-2'>
                                    <span className={style['input-tit']}>생년월일</span>
                                    <div className={style['birth-input-box']}>
                                        <div className={style['input-box']}>
                                            <input
                                                type="number"
                                                maxLength={6}
                                                value={birth}
                                                onChange={(e) => setBirth(e.target.value)}
                                                onInput={lengthChk}
                                                placeholder="YYMMDD"
                                            />
                                            <span className={style['line']}></span>
                                        </div>
                                        <div className={style['input-box']}>
                                            <input
                                                type="number"
                                                maxLength={1}
                                                value={genderCode}
                                                onChange={(e) => setGenderCode(e.target.value)}
                                                onInput={lengthChk}
                                                placeholder='0'

                                            />
                                            <span className={style['line']}></span>
                                            <span className={style['hideing']}>******</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {step >= 1 && step < 6 && (

                            <div className={style['input-wrap']}>
                                <div className='animation-2'>
                                    <span className={style['input-tit']}>이름</span>
                                    <div className={style['input-box']}>
                                        <input
                                            type="text"
                                            placeholder="이름 입력"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                        />
                                        <span className={style['line']}></span>
                                    </div>
                                </div>
                            </div>

                        )}

                    </div>
                    {/* 아이디 비밀번호 입력 화면:: E */}


                    {/* 아이디 확인 화면:: S */}
                    {step === 6 &&
                        <div className={style['content-box']} data-position="center">
                            <h2>입력하신 정보와 <br />일치하는 아이디 입니다 </h2>

                            <div className={style['inner-box']}>
                                <ul>
                                    <li>
                                        <p>아이디</p>
                                        <p><span>{ getMaskUserId(state?.usrId) }</span></p>
                                    </li>
                                    <li>
                                        <p>가입일</p>
                                        <p>{state?.signupDt}</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    }
                    {/* 아이디 확인 화면:: E */}



                    {/* 다음 버튼 */}
                    <div className="bottom-fixed-box">
                        <div className="inner-box">
                            <div className="btn-layout" data-btn-num="1">
                                <button
                                    className="btn"
                                    data-btn-type="fill-main"
                                    data-btn-size="lg"
                                    onClick={handleNext}
                                >
                                    <span>{step === 4 ? '인증번호 요청'
                                        : step === 5 ? '인증번호 확인'
                                            : step === 6 ? '로그인 하기'
                                                : '다음'
                                    }
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* 토스트 */}
                    {toast && (
                        <ToastPopup
                            setToast={setToast}
                            message={'준비중 입니다.'}
                            position="center"
                            opacity="90"
                        />
                    )}

                    {/* 통신사 바텀시트 미사용
                    <BottomSheet

                        scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                        expandOnContentDrag={false} // 내용 드래그로 확장 방지

                        open={open}
                        onDismiss={onDismiss}
                        snapPoints={({ minHeight }) => minHeight}
                        blocking={true}
                    >
                        <MobileTelecom
                            onClose={onDismiss}
                            onSelect={onTelecomSelect}
                        />
                    </BottomSheet>
                    */}


                </div>
            </div>
        </>
    )
}

export default FindId;
